import createBox from '../createBox';
const Box = createBox();
export default Box;